import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedUserInterest: cacheLs.get_user_interest()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
